// extracted by mini-css-extract-plugin
export default {"container":"styles_container__35-5+","title":"styles_title__9Pg7e","informative":"styles_informative__Mrtj4","column":"styles_column__onCyX","row":"styles_row__9vhI-"};